import React from 'react';
import PropTypes from 'prop-types';

import AttributeStaticListComponent from '../../../../common/components/attribute-list/attribute-static-list-component';

import { ResourceBlock } from '../../models/result';

import { apiGet } from '../../../../common/helpers/api-helpers';
import { LookupResult } from '../../../../common/models/lookup-result';
import { RECORD_STATUS } from '../../../../common/models/record-status';
import { MessageBoxGlobal, LoadingGlobal } from '../../../../common/globals/globals';
import { PropertyGridSelectValue } from '../../../../shared/components/property-grid/property-grid-component';

const IDS = {
  BLOCK_ID: 0
};
Object.freeze(IDS);

class BlockComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { lookups: null };

    this.loadLookups();
  }

  componentDidUpdate() {
    this.loadLookups();
  }

  loadLookups() {
    if (this.props.editing && this.state.lookups === null) {
      const apiUrl = 'api/resource/lookups/blocks?countryId=' + this.props.countryId;
      const onSuccess = (result) => this.setState({ lookups: new LookupResult(result) });
      apiGet(apiUrl, this.props.loadingGlobal.show, this.props.loadingGlobal.hide, this.props.messageBoxGlobal, onSuccess, undefined);
    }
  }

  render() {
    const { lookups } = this.state;
    const { editing, messageBoxGlobal, resourceBlocks, resourceBlockActions, id } = this.props;

    const onEdit = (id, value, item) => {
      switch (id) {
        case IDS.BLOCK_ID:
          item.blockId = Number(value);
          item.blockName = lookups.Blocks.find(obj => obj.key === item.blockId).value;
          break;
        default: throw new Error('Id ' + id + ' is not supported in BlockComponent.onEdit');
      }
      resourceBlockActions.onEdit(item);
    };

    const getTitle = (item) => {
      const value = item.blockName;
      return item.status === RECORD_STATUS.added && (value === undefined || value === null || value === '')
        ? '-New Block-'
        : value;
    };

    const items = resourceBlocks.map(item => {
      return {
        label: getTitle(item),
        data: item,
        sections: [{
          label: 'Block',
          rows: [
            { label: 'Block', values: [new PropertyGridSelectValue(IDS.BLOCK_ID, item.blockId, (value, id) => onEdit(id, value, item), 'key', 'value', lookups === null ? [{ key: item.blockId, value: item.blockName }] : lookups.Blocks)] }
          ]
        }]
      }
    });

    const add = () => {
      let newItem = new ResourceBlock(null);
      newItem.getNew(id);

      resourceBlockActions.onAdd(newItem);
    }

    return (
      <AttributeStaticListComponent
        editing={editing}
        messageBoxGlobal={messageBoxGlobal}
        items={items}
        itemDescription="block"
        canAdd
        canDelete
        onAdd={add}
        onDelete={resourceBlockActions.onDelete}
        onSelected={resourceBlockActions.onSelected}
        onAddPosition={"start"}
      />
    );
  }
}

BlockComponent.propTypes = {
  editing: PropTypes.bool.isRequired,
  messageBoxGlobal: PropTypes.instanceOf(MessageBoxGlobal).isRequired,
  loadingGlobal: PropTypes.instanceOf(LoadingGlobal).isRequired,
  resourceBlocks: PropTypes.arrayOf(PropTypes.instanceOf(ResourceBlock)).isRequired,
  countryId: PropTypes.number.isRequired,
  resourceBlockActions: PropTypes.shape({ onAdd: PropTypes.func.isRequired, onDelete: PropTypes.func.isRequired, onEdit: PropTypes.func.isRequired }).isRequired
};

export default BlockComponent;
